<template>
  <div class="container">
    <div class="row">
      <div class="col-md-6 mt-5 mx-auto">
        <form v-on:submit.prevent="register">
          <h1 class="h3 mb-3 font-weight-normal text-center">Cadastrar Usuário</h1>
          <div class="form-group">
            <label for="name">Nome</label>
            <input
              type="text"
              v-model="nome"
              class="form-control"
              name="nome"
              placeholder="Digite seu nome"
            />
            <div class="mt-1 alert alert-danger" v-if="$v.nome.$invalid && submitClicked">
              <span v-if="!$v.nome.required">Campo Obrigatório!</span>
            </div>
          </div>
          <div class="form-group">
            <label for="email">Email</label>
            <input
              type="email"
              v-model="email"
              class="form-control"
              name="email"
              placeholder="Digite um email"
            />
            <div class="mt-1 alert alert-danger" v-if="$v.email.$invalid && submitClicked">
              <span v-if="!$v.email.required">Campo Obrigatório!</span>
              <span v-if="!$v.email.email">Formato inválido!</span>
            </div>
          </div>
          <div class="form-group">
            <label for="password">Senha</label>
            <input
              type="password"
              v-model="password"
              class="form-control"
              name="password"
              placeholder="Digite uma senha"
            />
            <div class="mt-1 alert alert-danger" v-if="$v.password.$invalid && submitClicked">
              <span v-if="!$v.password.required">Campo Obrigatório!</span>
              <span
                v-if="!$v.password.minLength"
              >Mínimo {{$v.password.$params.minLength.min}} caracteres.</span>
            </div>
          </div>
          <button type="submit" class="btn btn-lg btn-success btn-block">Cadastrar</button>
        </form>
      </div>
    </div>
    <notifications group="novoUsuario" position="bottom center" :speed="500" />
    <notifications group="erroUsuario" position="bottom center" :speed="500" />
    <notifications group="exsiteUsuario" position="bottom center" :speed="500" />
  </div>
</template>

<script>
/* eslint-disable */
import axios from "axios";
import { required, minLength, email } from "vuelidate/lib/validators";
import router from "../router";

import EventBus from "./EventBus";
export default {
  data() {
    return {
      nome: "",
      email: "",
      password: "",
      submitClicked: false,
    };
  },
  validations: {
    nome: {
      required,
    },
    email: {
      required,
      email,
    },
    password: {
      required,
      minLength: minLength(10),
    },
  },
  methods: {
    register() {
      this.submitClicked = this.$v.$invalid;
      if (!this.$v.$invalid) {
        axios
          .post("https://www.sabios.net.br/api/usuario/registrar", {
            nome: this.nome,
            email: this.email,
            password: this.password,
          })
          .then((res) => {
            if (!res.data.error) {
              this.$notify({
                group: "novoUsuario",
                title: "Usuário cadastrado com sucesso!",
                type: "success",
              });
              router.push({ path: `/tutorial` }).catch(()=>{});
            } else {
              this.$notify({
                group: "exsiteUsuario",
                title: "Já existe um usuário com este email!",
                type: "warn",
              });
            }
          })
          .catch((err) => {
            this.$notify({
              group: "erroUsuario",
              title: "Erro ao cadastrar usuário...",
              type: "error",
            });
            console.log(err);
          });
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Registrar.vue